



















import {
  defineComponent,
  PropType,
  useContext,
  ref
} from '@nuxtjs/composition-api'
import ImagepixPicture from 'imagepix-vue2'
import { truncate } from '~/libs/utils'

export default defineComponent({
  components: {
    ImagepixPicture
  },
  props: {
    note: {
      type: Object as PropType<Note>,
      required: true
    },
    maxPackagesCount: {
      type: Number,
      default: 4
    }
  },
  setup(props) {
    const { $axios } = useContext()

    const packages = ref<Package[]>([])

    const fetchRelatedPackages = () => {
      $axios
        .$get<Package[]>(`/v2/notes/${props.note.id}/related_packages`, {
          params: { per: props.maxPackagesCount }
        })
        .then((data) => {
          packages.value = data
        })
    }

    const truncateTitle = (title: string) => truncate(title, 38)

    return {
      packages,
      fetchRelatedPackages,
      truncateTitle
    }
  }
})
